import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const WithdrawalIcon: React.FC<NormalIconProps> = (props) => (
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}>
		<path
			d="M22.1667 16.3333V23.3333M22.1667 23.3333L24.5 21M22.1667 23.3333L19.8334 21"
			stroke="#1A5F56"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M25.6667 14C25.6667 9.60025 25.6667 7.40036 24.2999 6.03352C22.933 4.66669 20.7332 4.66669 16.3334 4.66669H11.6667C7.26693 4.66669 5.06704 4.66669 3.70021 6.03352C2.33337 7.40036 2.33337 9.60025 2.33337 14C2.33337 18.3998 2.33337 20.5997 3.70021 21.9665C5.06704 23.3334 7.26693 23.3334 11.6667 23.3334H16.3334"
			stroke="#1A5F56"
			strokeWidth="1.75"
			strokeLinecap="round"
		/>
		<path d="M11.6667 18.6667H7" stroke="#1A5F56" strokeWidth="1.75" strokeLinecap="round" />
		<path d="M15.1667 18.6667H14.5834" stroke="#1A5F56" strokeWidth="1.75" strokeLinecap="round" />
		<path d="M2.33337 11.6667L25.6667 11.6667" stroke="#1A5F56" strokeWidth="1.75" strokeLinecap="round" />
	</svg>
);
